import { Injectable } from "@angular/core";
import { map } from "rxjs";
import {
  ApiResponse,
  FetchResponse,
} from "src/app/shared/models/api-response.interface";
import { CategoryApiService } from "../../product-list/services/category-api.service";
import { TopCategories } from "../models/topcategories-interface";

@Injectable({
  providedIn: "root",
})
export class TopCategoriesApiService {
  constructor(private categoryApiService: CategoryApiService) {}

  fetchTopCategories() {
    return this.categoryApiService.fetchCategoriesWithSub(true).pipe(
      map((response): ApiResponse<FetchResponse<TopCategories[]>> => {
        const subCategories = (response.data ?? [])
          .flatMap((category) => (category.subCategories ?? []).map((item) => ({
            ...item,
            categoryId: category.id,
          })))
          .filter((item) => item.productCount > 0)
          .sort((a, b) => b.productCount - a.productCount
            || a.displayOrder - b.displayOrder || a.id.localeCompare(b.id));
        const items: TopCategories[] = subCategories.map((item) => ({
          id: item.id,
          categoryId: item.categoryId,
          name: item.name,
          description: item.description,
          imageUrl: item.imageUrl,
          totalProducts: item.productCount,
        }));
        const totalCount = items.length;

        return {
          ...response,
          data: {
            pageIndex: 0,
            pageSize: totalCount || 1,
            totalCount,
            totalPages: 1,
            items,
          },
        };
      })
    );
  }
}
